/**
 * @since 0.3.0
 * @component
 */
export default {
  CHANGE_LANGUAGE: 'App/CHANGE_LOCALE',
  ROUTE_REDUCER_KEY: 'router',
  LANGUAGE_REDUCER_KEY: 'language',
  TRANSACTION_REDUCER_KEY: 'transaction',
  ACTION_NAMESPACE: '[namespace]',
  ACTION_IDENTIFIER: '[identifier]',
} as const;
